<template>
  <div>
    <Breadcrumbs main="Beacon" title="Case Management" />
    <div class="container-fluid">
      <div class="card px-4 pt-3" style="height: 80vh; overflow-y: scroll">
        <ValidationObserver v-slot="{ valid }" ref="form">
          <b-form class="row" @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="col-12 text-right pr-3">
              <toggle-button :width="60" @change="updateTemplate" v-model="isEdit" :sync="true"
                :labels="{ checked: 'Edit', unchecked: 'Preview' }" />
            </div>
            <div class="col-6">
              <div class="row">
                <ValidationProvider v-for="(form, i) in formL" :key="i" :class="`col-${form.col} `" :name="form.lable"
                  :rules="i == 7 || i == 8 || i == 9 || i == 10 || i == 13 || i == 14
                                        ? ''
                                        : 'required|customRegex|customRegexCRLF|max_length200'
                                      " v-slot="{ errors }">
                  <b-form-group :label-for="`input-${i}`">
                    <template #label>
                      {{ form.checkbox ? null : form.lable
                                              }}<span v-if="i != 8 && i != 9 && i != 10 && i != 13 && i != 14"
                        class="text-danger">{{ form.checkbox ? null : '*' }}</span>
                    </template>
                    <template #description>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </template>
                    <div class="checkbox-animated" v-if="form.checkbox">
                      <label class="d-block" :for="`input-${i}`">
                        <input class="checkbox_animated h-50" :id="`input-${i}`" type="checkbox" v-model="form.value" />
                        {{ form.lable }}
                      </label>
                    </div>
                    <v-select v-else-if="form.select" :clearable="i == 8 ? true : false"
                      :label="form.type ? 'type' : 'name'" v-model="form.value" :multiple="i > 6" @input="
                                              form.type
                                                ? fillForm(form.value)
                                                : replaceTemplate(form.lable, $event)
                                              " :disabled="i == 7 || form.option.length == 0" :options="form.option" />
                    <date-picker v-else-if="form.time" v-model="form.value" @input="form.time ? replaceTemplate() : null"
                      type="datetime" format="YYYY-MM-DD HH:mm"></date-picker>
                    <b-form-input v-else @input="form.code ? replaceTemplate() : null" v-model="form.value"
                      :id="`input-${i}`" type="text" size="sm"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-6">
              <template v-if="!isEdit">
                <b-form-group v-for="(form, i) in formR" :key="i" size="sm" :class="`col-${form.col}`"
                  :label="form.checkbox ? null : form.lable" :label-for="`input-${i}`">
                  <vue-editor v-if="form.edit" v-model="form.value"
                    :style="'background-color:#e9ecef;font-family: Tahoma; font-size: 10px;'"
                    :disabled="true"></vue-editor>

                  <!-- <quill-editor
                    v-if="form.edit"
                    v-model="form.value"
                    :style="'background-color:#e9ecef;font-family: Tahoma; font-size: 10px;'"
                    :disabled="true"
                    :options="editorOption"
                  ></quill-editor> -->

                  <b-form-textarea v-else-if="form.textarea" :id="`input-${i}`" v-model="form.value" rows="3" max-rows="3"
                    :disabled="true"></b-form-textarea>
                  <vue-tags-input v-else-if="form.tag" :placeholder="i == 3 ? 'Add Email' : 'Add Phone Number'"
                    v-model="form.value" @before-adding-tag="
                                          i == 3 ? checkEmail($event) : checkNumber($event)
                                          " :tags="form.tags" :separators="separators"
                    @tags-changed="(newTags) => (form.tags = newTags)" />
                  <b-form-input v-else :id="`input-${i}`" type="text" v-model="form.value" :disabled="true"
                    size="sm"></b-form-input>
                </b-form-group>
              </template>
              <template v-else>
                <b-form-group v-for="(form, i) in formR" :key="i" size="sm" :class="`col-${form.col}`"
                  :label="form.checkbox ? null : form.lable" :label-for="`input-${i}`">
                  <vue-editor v-if="form.edit" @input="editMainTemplate(form.lable, $event)"
                    :value="isEdit ? massage : ''" :style="!checkBox || !valid
                                            ? 'background-color:#e9ecef; pointer-events:none;font-family: Tahoma; font-size: 10px;'
                                            : 'font-family: Tahoma; font-size: 10px;'
                                          " :disabled="!checkBox || !valid"></vue-editor>
                  <!-- <quill-editor
                    v-if="form.edit"
                    @input="editMainTemplate(form.lable, $event)"
                    :options="editorOption"
                    :value="isEdit ? massage : ''"
                    :style="
                      !checkBox || !valid
                        ? 'background-color:#e9ecef; pointer-events:none;font-family: Tahoma; font-size: 10px;'
                        : 'font-family: Tahoma; font-size: 10px;'
                    "
                    :disabled="!checkBox || !valid"
                  >
                  </quill-editor> -->

                  <b-form-textarea v-else-if="form.textarea" @input="editMainTemplate(form.lable, $event)"
                    :value="isEdit ? sms_massage : ''" :id="`input-${i}`" rows="3" max-rows="3"
                    :disabled="!checkBox || !valid"></b-form-textarea>
                  <vue-tags-input v-else-if="form.tag" :placeholder="i == 3 ? 'Add Email' : 'Add Phone Number'"
                    v-model="form.value" @before-adding-tag="
                                          i == 3 ? checkEmail($event) : checkNumber($event)
                                          " :tags="form.tags" :separators="separators"
                    @tags-changed="(newTags) => (form.tags = newTags)" />
                  <b-form-input v-else :id="`input-${i}`" type="text" @input="editMainTemplate(form.lable, $event)"
                    :value="isEdit ? subject : ''" :disabled="!checkBox || !valid" size="sm"></b-form-input>
                </b-form-group>
              </template>
              <div class="d-flex justify-content-end mb-3">
                <b-button variant="primary" class="btn-pill mx-3" @click="$router.go(-1)"><i
                    class="icofont icofont-rounded-left"></i> Back</b-button>
                <b-button variant="danger" class="btn-pill mx-3" @click="onReset"><i
                    class="icofont icofont-spinner-alt-3"></i> Reset</b-button>
                <b-button variant="success" class="btn-pill mx-3" type="submit" :disabled="!checkBox || !valid"><i
                    class="icofont icofont-envelope"></i> Preview</b-button>

                <b-modal v-model="modalShow" size="lg" title="Preview" centered>
                  <div class="ribbon-wrapper card m-0" v-if="formL[12].value == true">
                    <div class="card-body p-3">
                      <div class="ribbon ribbon-primary">
                        Sending Information
                      </div>
                      <p v-if="formL[7].value !== ''">
                        <span class="font-weight-bolder"> Send To : </span>
                        <span v-for="(item, i) in formL[7].value.concat(
                                                      formL[8].value
                                                    )" :key="i">
                          {{ item.name }}
                          {{
                                                        formL[7].value.concat(formL[8].value).length - 1 > i
                                                        ? ','
                                                        : null
                                                      }}
                        </span>
                      </p>
                      <p>
                        <span class="font-weight-bolder">Send Type : </span>
                        {{ formL[11].value ? formL[11].lable : null }}
                        {{
                                                    (formL[11].value == true) & (formL[12].value == true)
                                                    ? ', '
                                                    : null
                                                  }}{{ formL[12].value ? formL[12].lable : null }}
                      </p>

                      <p v-if="formR[3].tags.length > 0 && formL[12].value == true
                                              ">
                        <span class="font-weight-bolder">Addition Email :
                        </span>
                        <span v-for="(tag, i) in formR[3].tags" :key="i">
                          <b-badge class="m-r-5" variant="light">{{
                                                        tag.text
                                                      }}</b-badge>
                        </span>
                      </p>

                      <p v-if="formR[4].tags.length > 0 && formL[11].value == true
                                              ">
                        <span class="font-weight-bolder">Addition SMS : </span>
                        <span v-for="(tag, i) in formR[4].tags" :key="i">
                          <b-badge class="m-r-5" variant="light">{{
                                                        tag.text
                                                      }}</b-badge>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="ribbon-wrapper card m-0" v-if="formL[12].value == true">
                    <div class="card-body p-3">
                      <div class="ribbon ribbon-primary">Email</div>
                      <h4 class="mb-3">{{ formR[0].value }}</h4>
                      <p class="border rounded p-3" style="height: 100%" v-html="formR[1].value"></p>
                    </div>
                  </div>

                  <div class="ribbon-wrapper card m-0" v-if="formL[11].value == true">
                    <div class="card-body p-3">
                      <div class="ribbon ribbon-primary">SMS</div>
                      <p class="border rounded p-3" style="height: 100%">
                        {{ formR[2].value }}
                      </p>
                    </div>
                  </div>

                  <template #modal-footer>
                    <button @click="modalShow = !modalShow"
                      class="btn btn-danger btn-pill btn-sm m-1 d-flex align-item-center">
                      <i class="icofont icofont-close mr-1" style="font-size: 1rem"></i>
                      Cancel
                    </button>
                    <button @click="sendCaseManage" class="btn btn-success btn-pill btn-sm m-1 d-flex align-item-center">
                      <i class="icofont icofont-send-mail mr-1" style="font-size: 1.2rem"></i>
                      Send
                    </button>
                  </template>
                </b-modal>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import { requestService } from './../../_services';
import { extend } from 'vee-validate';
import { VueEditor } from 'vue2-editor';

import Quill from 'quill';
import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

extend('required', {
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1,
    };
  },
  computesRequired: true,
});

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      separators: [';', ',', ' ', '<', '>'],
      modalShow: false,
      editorOption: {
        modules: {
          //imageDrop: true,
          // imagePaste: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            // ['link', 'image', 'video'],
            ['template-partediario'],
          ],
          // imageResize: {
          //   displayStyles: {
          //     backgroundColor: 'black',
          //     border: 'none',
          //     color: 'white',
          //   },
          //   modules: ['Resize', 'DisplaySize', 'Toolbar'],
          // },
        },
      },
      formL: [
        {
          value: '',
          col: 12,
          lable: 'Description',
        },
        {
          value: '',
          col: 6,
          lable: 'Incident ID',
          code: 'INCxxxxxxx',
        },
        {
          value: null,
          col: 6,
          lable: 'Application',
          code: 'AAAAA',
          option: [],
          select: true,
        },
        {
          value: '',
          col: 6,
          lable: 'Company',
          option: [],
          select: true,
        },
        {
          value: '',
          col: 6,
          lable: 'Category',
          option: [],
          code: 'GGGGG',
          select: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Announcement Type',
          option: [],
          type: true,
          select: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Symptom',
          option: [],
          code: 'SEEEE & STTTT',
          select: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Group',
          option: [],
          select: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Additional Group',
          option: [],
          select: true,
        },
        {
          value: '',
          col: 6,
          lable: 'Acknowledge Time',
          time: true,
          code: 'D1111 T1111',
        },
        {
          value: '',
          col: 6,
          lable: 'Occurring Time',
          time: true,
          code: 'D2222 T2222',
        },
        {
          value: true,
          col: 4,
          lable: 'Send SMS',
          checkbox: true,
        },
        {
          value: true,
          col: 4,
          lable: 'Send Email',
          checkbox: true,
        },
        {
          value: '',
          col: 6,
          lable: 'Expected Resolving Time',
          time: true,
          code: 'D3333 T3333',
        },
        {
          value: '',
          col: 6,
          lable: 'Resolving Time',
          time: true,
          code: 'D4444 T4444',
        },
        {
          value: '',
          col: 12,
          lable: 'Sender',
          code: 'UUUUU',
        },
      ],
      formR: [
        {
          value: '',
          col: 12,
          lable: 'Email Subject',
        },
        {
          value: '',
          col: 12,
          lable: 'Email Message',

          edit: true,
        },
        {
          value: '',
          col: 12,
          lable: 'SMS Message',

          textarea: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Additional Email',
          tags: [],
          tag: true,
        },
        {
          value: '',
          col: 12,
          lable: 'Additional SMS',
          tags: [],
          tag: true,
        },
      ],
      massage: '',
      sms_massage: '',
      subject: '',
      isEdit: false,
    };
  },

  computed: {
    checkBox() {
      return this.formL[11].value || this.formL[12].value;
    },
  },
  async created() { },
  async beforeMount() {
    await this.applicationOption();
    await this.announcementOption();
    await this.symptomOption();
    await this.groupOption();
  },

  async mounted() {
    let userinfo = localStorage.getItem('userinfo');

    userinfo = JSON.parse(userinfo);
    this.formL[15].value = userinfo.sender;
    if (this.$route.query.id) {
      await this.getCaseById();
    }
  },

  methods: {
    updateTemplate(e) {
      if (!e.value) {
        this.replaceTemplate();
      }
    },
    editMainTemplate(form, e) {
      if (form == 'Email Message') {
        this.massage = e;
      } else if (form == 'Email Subject') {
        this.subject = e;
      } else if (form == 'SMS Message') {
        this.sms_massage = e;
      }
    },
    async getCaseById() {
      let url = `/api/casemanagement/show/${this.$route.query.id}`;
      await requestService
        .GetFetch('beacon', url)
        .then(async (response) => {
          if (response.status == 200) {
            await response.text().then(async (text) => {
              const data = text && JSON.parse(text);
              this.formL[0].value = data.data[0].description;
              this.formL[1].value = data.data[0].incident;

              this.formL[2].value = this.formL[2].option.find(
                (item) => item._id === data.data[0].application_id
              );

              await this.ruleOption(this.formL[2].value._id);
              this.formL[3].value = this.formL[3].option.find(
                (item) => item._id === data.data[0].company_id
              );
              this.formL[4].value = this.formL[4].option.find(
                (item) => item._id === data.data[0].category_id
              );
              this.formL[5].value = this.formL[5].option.find(
                (item) => item._id === data.data[0].announcement_id
              );

              // this.formL[6].value =
              await this.symptomOption();
              this.formL[6].value = this.formL[6].option.find(
                (item) => item._id === data.data[0].symptom_id
              );
              if (data.data[0].acknowledge_time != '') {
                this.formL[9].value = new Date(data.data[0].acknowledge_time);
              }
              if (data.data[0].occurring_time != '') {
                this.formL[10].value = new Date(data.data[0].occurring_time);
              }
              this.formL[11].value = data.data[0].send_sms;
              this.formL[12].value = data.data[0].send_email;
              if (data.data[0].expected_time != '') {
                this.formL[13].value = new Date(data.data[0].expected_time);
              }
              if (data.data[0].resolve_time != '') {
                this.formL[14].value = new Date(data.data[0].resolve_time);
              }
              this.formL[15].value = data.data[0].sender;

              data.data[0].additional_email.map((mail) => {
                this.formR[3].tags.push({
                  text: mail,
                  tiClasses: ['ti-valid'],
                });
              });
              data.data[0].additional_sms.map((number) => {
                this.formR[4].tags.push({
                  text: number,
                  tiClasses: ['ti-valid'],
                });
              });
              this.massage = data.data[0].message_email;
              this.sms_massage = data.data[0].message_sms;
              this.subject = data.data[0].subject_email;
              await this.fillForm(this.formL[5].value, 'temp');
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
    changeType() {
      alert('your save will be discard');
    },
    async sendCaseManage() {
      var group = [];
      if (this.formL[7].value != '' && this.formL[7].value != null) {
        this.formL[7].value.forEach((element) => {
          group.push(element._id);
        });
      }
      var additional_group = [];
      if (this.formL[8].value != '' && this.formL[8].value != null) {
        this.formL[8].value.forEach((element) => {
          additional_group.push(element._id);
        });
      }
      const Case = {
        description: this.formL[0].value,
        incident: this.formL[1].value,
        application_id: this.formL[2].value._id,
        company_id: this.formL[3].value._id,
        category_id: this.formL[4].value._id,
        announcement_id: this.formL[5].value._id,
        symptom_id: this.formL[6].value._id,
        group_id: group,
        additional_group_id: additional_group,
        acknowledge_time: this.formL[9].value,
        occurring_time: this.formL[10].value,
        send_sms: this.formL[11].value,
        send_email: this.formL[12].value,
        expected_time: this.formL[13].value,
        resolve_time: this.formL[14].value,
        sender: this.formL[15].value,
        subject_email: this.formR[0].value,
        message_email: this.formR[1].value,
        message_sms: this.formR[2].value,
        additional_email: this.formR[3].tags.map((mail) => mail.text),
        additional_sms: this.formR[4].tags.map((sms) => sms.text),
      };
      this.modalShow = false;

      const url = `/api/casemanagement`;
      const resCase = await requestService.PostFetch('beacon', url, Case);
      const res = await resCase.json();
      this.$swal.fire({
        icon: 'success',
        title: 'Your Case has been Sent',
        showConfirmButton: false,
        timer: 1500,
      });
      this.onReset();
    },
    checkEmail(obj) {
      //if (obj.tag.text.match(/[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,3}/)) obj.addTag();
      if (obj.tag.text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)) obj.addTag();
      else this.$notify({ text: 'Input is not Email', type: 'warn' });
    },
    checkNumber(obj) {
      if (
        obj.tag.text.match(
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        )
      )
        obj.addTag();
      else this.$notify({ text: 'Input is not PhoneNumber', type: 'warn' });
    },
    generateTemplate(input) {
      let generate = input
        .replaceAll(
          this.formL[1].code,
          this.formL[1].value == '' ? this.formL[1].code : this.formL[1].value
        )
        .replaceAll(
          this.formL[2].code,
          this.formL[2].value == ''
            ? this.formL[2].code
            : this.formL[2].value.name
        )
        .replaceAll(
          this.formL[4].code,
          this.formL[4].value == ''
            ? this.formL[4].code
            : this.formL[4].value.name
        )
        .replaceAll(
          this.formL[6].code.split(/ & | /)[0],
          this.formL[6].value == ''
            ? this.formL[6].code.split(/ & | /)[0]
            : this.formL[6].value.name.split(',')[0]
        )
        .replaceAll(
          this.formL[6].code.split(/ & | /)[1],
          this.formL[6].value == ''
            ? this.formL[6].code.split(/ & | /)[1]
            : this.formL[6].value.name.split(',')[1]
        )
        .replaceAll(
          this.formL[9].code.split(/ & | /)[0],
          this.formL[9].value == '' || this.formL[9].value == null
            ? this.formL[9].code.split(/ & | /)[0]
            : this.$moment(this.formL[9].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[0]
        )
        .replaceAll(
          this.formL[9].code.split(/ & | /)[1],
          this.formL[9].value == '' || this.formL[9].value == null
            ? this.formL[9].code.split(/ & | /)[1]
            : this.$moment(this.formL[9].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[1]
        )
        .replaceAll(
          this.formL[10].code.split(/ & | /)[0],
          this.formL[10].value == '' || this.formL[10].value == null
            ? this.formL[10].code.split(/ & | /)[0]
            : this.$moment(this.formL[10].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[0]
        )
        .replaceAll(
          this.formL[10].code.split(/ & | /)[1],
          this.formL[10].value == '' || this.formL[10].value == null
            ? this.formL[10].code.split(/ & | /)[1]
            : this.$moment(this.formL[10].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[1]
        )
        .replaceAll(
          this.formL[13].code.split(/ & | /)[0],
          this.formL[13].value == '' || this.formL[13].value == null
            ? this.formL[13].code.split(/ & | /)[0]
            : this.$moment(this.formL[13].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[0]
        )
        .replaceAll(
          this.formL[13].code.split(/ & | /)[1],
          this.formL[13].value == '' || this.formL[13].value == null
            ? this.formL[13].code.split(/ & | /)[1]
            : this.$moment(this.formL[13].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[1]
        )
        .replaceAll(
          this.formL[14].code.split(/ & | /)[0],
          this.formL[14].value == '' || this.formL[14].value == null
            ? this.formL[14].code.split(/ & | /)[0]
            : this.$moment(this.formL[14].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[0]
        )
        .replaceAll(
          this.formL[14].code.split(/ & | /)[1],
          this.formL[14].value == '' || this.formL[14].value == null
            ? this.formL[14].code.split(/ & | /)[1]
            : this.$moment(this.formL[14].value)
              .format('DD/MM/YYYY HH:mm')
              .split(' ')[1]
        )
        .replaceAll(
          this.formL[15].code,
          this.formL[15].value == ''
            ? this.formL[15].code
            : this.formL[15].value
        );
      return generate;
    },

    async replaceTemplate(form, e) {
      if (form === 'Application') {
        await this.ruleOption(e._id);
      }
      this.massage = this.massage.replaceAll(
        '\t',
        '&nbsp;&nbsp;&nbsp;&nbsp;'
      );
      this.formR[1].value = this.generateTemplate(this.massage);

      this.formR[0].value = this.generateTemplate(this.subject);
      this.formR[2].value = this.generateTemplate(this.sms_massage);
    },
    onSubmit() {
      this.replaceTemplate();
      this.massage == '';
      this.sms_massage == ''
        ? this.$notify({ text: 'Please fill email', type: 'warn' })
        : (this.modalShow = !this.modalShow);
    },
    onReset() {
      console.log('onReset');
      this.formL.map((item) => {
        if (item.checkbox) {
          item.value = false;
        } else if (item.lable.match('Sender')) {
          return 0;
        } else {
          item.value = '';
        }
      });
      this.formR.map((item) => {
        item.value = '';
        item.tags = [];
      });
      this.isEdit = false;
      this.subject = '';
      this.massage = '';
      this.sms_massage = '';
      this.formL[11].checkbox = true;
      this.formL[12].checkbox = true;
      this.formL[11].value = true;
      this.formL[12].value = true;
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
      // this.$router.push('/beacon/case-management').catch();
    },
    fillForm(item, temp = null) {
      if (item) {
        if (temp != null) {
          this.formR[0].value = this.subject;
          this.formR[1].value = this.massage;
          this.formR[2].value = this.sms_massage;
        } else {
          this.formR[0].value = item.email_subject;
          this.formR[1].value = item.email_message;
          this.formR[2].value = item.sms_message;
        }
        this.massage = this.formR[1].value;
        this.sms_massage = this.formR[2].value;
        this.subject = this.formR[0].value;
        this.replaceTemplate();
      } else {
        this.formR[0].value = '';
        this.formR[1].value = '';
        this.formR[2].value = '';
        this.massage = '';
        this.sms_massage = '';
        this.subject = '';
      }
    },

    async applicationOption() {
      let url = `/api/application/all`;
      let self = this;
      const resData = await requestService.GetFetch('beacon', url);
      if (resData.status === 429) {
        setTimeout(function () {
          self.applicationOption();
        }, 2000);
      } else {
        const data = await resData.json();
        this.formL[2].option = data.data ? data.data : [];
      }
    },
    async announcementOption() {
      let url = `/api/announcement/all`;
      let self = this;
      const resData = await requestService.GetFetch('beacon', url);
      if (resData.status === 429) {
        setTimeout(function () {
          self.announcementOption();
        }, 2000);
      } else {
        const data = await resData.json();
        this.formL[5].option = data.data ? data.data : [];
      }
    },
    async symptomOption() {
      let url = `/api/symptom/all`;
      let self = this;
      const resData = await requestService.GetFetch('beacon', url);
      if (resData.status === 429) {
        setTimeout(function () {
          self.symptomOption();
        }, 2000);
      } else {
        const data = await resData.json();
        this.formL[6].option = data.data ? data.data : [];
      }
    },
    async groupOption() {
      let url = `/api/group/all`;
      let self = this;
      const resData = await requestService.GetFetch('beacon', url);
      if (resData.status === 429) {
        setTimeout(function () {
          self.groupOption();
        }, 2000);
      } else {
        const data = await resData.json();
        this.formL[8].option = data.data ? data.data : [];
      }
    },
    async ruleOption(id) {
      let url = `/api/rule/application/${id}`;
      const resData = await requestService.GetFetch('beacon', url);
      const data = await resData.json();
      if (data.data === null) {
        this.formL[3].option = [];
        this.formL[3].value = '';
        this.formL[4].option = [];
        this.formL[4].value = '';
        this.formL[7].option = [];
        this.formL[7].value = '';
        this.formL[5].value = '';
        this.formL[6].value = '';
        this.subject = '';
        this.massage = '';
        this.sms_massage = '';
        this.formR.map((item) => {
          item.value = '';
          item.tags = [];
        });
      } else {
        this.formL[3].option = data.data.company;
        this.formL[4].option = data.data.category;
        this.formL[7].option = data.data.group;
      }

      this.formL[7].value = this.formL[7].option;
    },
  },
};
</script>

<style>
.ql-font-charm {
  font-family: 'Charm', cursive;
}

.ql-editor {
  height: 30vh !important;
  overflow-y: scroll;
}

label {
  margin-bottom: 0rem !important;
}

.form-group {
  margin-bottom: 0.8rem !important;
}

.mx-datepicker {
  width: 100% !important;
}

.vue-tags-input[data-v-61d92e31] {
  max-width: 100% !important;
}

.ti-input[data-v-61d92e31] {
  border-radius: 0.3rem !important;
}

.ti-tag[data-v-61d92e31] {
  color: #2971ff !important;
  background-color: #e4edff !important;
}

.ti-tag.ti-invalid[data-v-61d92e31],
.ti-tag.ti-tag.ti-deletion-mark[data-v-61d92e31] {
  background-color: #e54d42 !important;
  color: #e4edff !important;
}
</style>
